import { IRequestParamDistrict } from '@/types/alternativeServices';
import Request from '@/api/request';

const api = new Request('lk/statement/');

export function updateDistrict(data: IRequestParamDistrict): Promise<object> {
  return api.post('updateDistrict', data);
}
